<div class="attachDocument">
    <div *ngIf="otherFiles.length > 0" class="text-download-document">
        <p class="copec-bold-16">Archivos adjuntos</p>
    </div>

    <div *ngIf="otherFiles.length > 0">
      <div *ngFor="let doc of otherFiles; index as i">
          <div *ngIf="statusRequest !== 'Con error' && !correction" style="display: flex;  width: 720px;">
              <div class="input-download-document" style="width: 720px; margin-left: 16px;">
                  <p class="copec-lg-14"><img src="../assets/icon-summary/document.svg" alt="img">
                      {{truncateText(doc.valor)}}</p>
                  <img src="../assets/icon-summary/download.svg" alt="" (click)="downloadFile(doc.valor)">
              </div>
          </div>
          <div style="display: flex; margin-left: 16px; width: 732px;" *ngIf="correction">
              <p style="display: contents; margin-right: 2px;">
                  <input type="checkbox" 
                  [value]="doc.valor"
                  name="certificado"
                  [checked]="doc.corregir"
                  (click)="selectionData($event, 'Archivos adjuntos', 'archivos', summaryData_archivos.indexOf(doc))">   
              <div class="input-download-document" style="width:712px ; margin-left:9px;">
                  <p class="copec-lg-14">
                      <img src="../assets/icon-summary/document.svg" alt="img">
                      {{truncateText(doc.valor)}}
                  </p>
                  <img src="../assets/icon-summary/download.svg" alt="img" (click)="downloadFile(doc.valor)">
              </div>
          </div>
          <div style="display: flex; width: 748px;" *ngIf="statusRequest === 'Con error'">
              <div class="input-download-document" style="width:748px ; margin-left:16px;">
                  <p class="copec-lg-14"><img src="../assets/icon-summary/warning.svg" alt="img"
                      *ngIf="doc.corregir=== true && statusRequest === 'Con error'" style="height: 32px;  padding:4px 9px 4px 4px;">
                      <img src="../assets/icon-summary/document.svg" alt="img">
                      {{truncateText(doc.valor)}}
                  </p>
                  <img src="../assets/icon-summary/download.svg" alt="img" (click)="downloadFile(doc.valor)">
              </div>
          </div>
     </div>
    </div>

  
    <div *ngIf="adminFiles.length > 0" style="margin-top: 12px;">
      <div class="text-download-document">
          <p class="copec-bold-16">{{adminSectionTitle}}</p>
      </div>

      <div *ngFor="let doc of adminFiles; index as iAdmin">
          <div *ngIf="statusRequest !== 'Con error' && !correction" style="display: flex;  width: 720px;">
              <div class="input-download-document" style="width: 720px; margin-left: 16px;">
                  <p class="copec-lg-14"><img src="../assets/icon-summary/document.svg" alt="img">
                      {{truncateText(doc.valor)}}</p>
                  <img src="../assets/icon-summary/download.svg" alt="" (click)="downloadFile(doc.valor)">
              </div>
          </div>
          <div style="display: flex; margin-left: 16px; width: 732px;" *ngIf="correction">
              <p style="display: contents; margin-right: 2px;">
                  <input type="checkbox" 
                  [value]="doc.valor"
                  name="certificado"
                  [checked]="doc.corregir"
                  (click)="selectionData($event, adminSectionTitle, 'archivos', summaryData_archivos.indexOf(doc))">   
              <div class="input-download-document" style="width:712px ; margin-left:9px;">
                  <p class="copec-lg-14">
                      <img src="../assets/icon-summary/document.svg" alt="img">
                      {{truncateText(doc.valor)}}
                  </p>
                  <img src="../assets/icon-summary/download.svg" alt="img" (click)="downloadFile(doc.valor)">
              </div>
          </div>
          <div style="display: flex; width: 748px;" *ngIf="statusRequest === 'Con error'">
              <div class="input-download-document" style="width:748px ; margin-left:16px;">
                  <p class="copec-lg-14"><img src="../assets/icon-summary/warning.svg" alt="img"
                      *ngIf="doc.corregir=== true && statusRequest === 'Con error'" style="height: 32px;  padding:4px 9px 4px 4px;">
                      <img src="../assets/icon-summary/document.svg" alt="img">
                      {{truncateText(doc.valor)}}
                  </p>
                  <img src="../assets/icon-summary/download.svg" alt="img" (click)="downloadFile(doc.valor)">
              </div>
          </div>
     </div>
    </div>
</div>